// If the button is only a settings icon, we should render a button due to card action style guide.
export function isSettingsIconButton(actionConfig) {
  return actionConfig.iconName === 'settings' && !actionConfig.label;
}